<template>
  <div :class="$b()">
    <div :class="$b('image-container')">
      <picture>
        <source
          media="(min-width: 800px)"
          :srcset="background.src"
        />
        <img
          :src="mobileImage.src"
          alt=""
          :class="$b('image')"
        />
      </picture>
    </div>
    <div :class="$b('container')">
      <BaseHeading
        tag="h4"
        size="h3"
        :class="$b('title')"
      >
        {{ title }}

        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="subtitle"
          :class="$b('subtitle')"
          v-html="subtitle"
        />
        <!-- eslint-enable vue/no-v-html -->
      </BaseHeading>
      <BaseCopy
        tag="p"
        size="body"
        :class="$b('copy')"
      >
        {{ copy }}
      </BaseCopy>
    </div>
    <div
      v-if="gradientOverlay"
      :class="$b('overlay')"
    />
  </div>
</template>

<script>
export default {
  name: 'TextBackground',

  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    copy: {
      type: String,
      default: '',
    },
    background: {
      type: Object,
      required: true,
    },
    mobileBackground: {
      type: Object,
      default: () => {},
    },
    gradientOverlay: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    mobileImage() {
      return this.mobileBackground?.url
        ? this.mobileBackground
        : this.background
    },
  },
}
</script>

<style lang="postcss">
.TextBackground {
  @apply mb-sm p-xs md:p-md
    bg-grey
    text-white
    relative;
  border-radius: 10px;

  + *:not(.TextBackground) {
    @apply mt-md md:mt-lg;
  }
}

.TextBackground__image-container {
  @apply absolute top-0 left-0 w-full h-full;
  z-index: 1;
}

.TextBackground__image {
  @apply object-cover h-full w-full;
  border-radius: 10px;
}

.TextBackground__container {
  @apply p-xs md:p-0
    relative;
  z-index: 3;
}

.TextBackground__title {
  @apply mb-sm text-xl md:text-2xl
    flex items-center justify-between;
}

.TextBackground__subtitle {
  @apply text-sm md:text-base text-right;
}

.TextBackground__copy {
  @apply mb-0;
}

.TextBackground__overlay {
  @apply absolute w-full left-0 bottom-0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 60%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  z-index: 2;
}
</style>
